export default "__VITE_ASSET__D9_5AqA7__"